import routerOptions0 from "/home/userapp/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/userapp/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}